var map = {
	"./SideScroll.png": 3346,
	"./data/1/arked.png": 3736,
	"./data/1/arked1.png": 3640,
	"./data/1/arked2.png": 1095,
	"./data/1/arked3.jpg": 3003,
	"./data/1/arked3.png": 552,
	"./data/1/arkedlogo.png": 293,
	"./data/1/home-video-low.mp4": 9220,
	"./data/2/szoszak1.jpg": 8507,
	"./data/2/szoszak2.jpg": 1022,
	"./data/2/szoszak3.jpg": 2640,
	"./data/2/szoszak4.jpg": 1593,
	"./data/2/szoszak5.jpg": 7856,
	"./data/3/kombucha1.png": 8866,
	"./data/3/logo.bmp": 4743,
	"./data/data": 6351,
	"./data/data.json": 6351,
	"./home-video-low.mp4": 6593,
	"./icons/axios.png": 2070,
	"./icons/expo.png": 816,
	"./icons/express.png": 7706,
	"./icons/firebase.png": 3253,
	"./icons/git.png": 8710,
	"./icons/github.png": 6127,
	"./icons/java.png": 7816,
	"./icons/json.png": 1651,
	"./icons/next.png": 1946,
	"./icons/nextjs.svg": 9283,
	"./icons/node.png": 9414,
	"./icons/react.png": 3364,
	"./icons/restapi.png": 1976,
	"./icons/sql.png": 5458,
	"./icons/typescript.png": 8453,
	"./info": 3976,
	"./info.json": 3976,
	"./line-m.png": 6560,
	"./line.png": 5621,
	"./logo-github.png": 6141,
	"./logo-linkedin.png": 275,
	"./logo.bmp": 7728,
	"./mm.png": 7740,
	"./mm2.png": 7586,
	"./profile_small.jpg": 4348,
	"./szoszak.jpg": 3913,
	"./szoszak1.jpg": 4092,
	"./top-line-m.png": 2269,
	"./top-line.png": 9731,
	"./txt.txt": 8988,
	"./vector-up.png": 2973
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;